<div class="container flex mt-8">
  <div class="rounded-2xl bg-white  w-full col-md-8 mx-auto"
       style="background-image: url('/src/assets/images/emblembg.png'); background-repeat: no-repeat; background-position: center; background-size: 55%">

    <div class="flex items-center p-4">
      <div class="bg-gradient2 move-left cursor-pointer rounded-md p-2" matTooltip="Back">
        <span (click)="goBack()">
          <strong class="flex justify-center items-center">
            <mat-icon svgIcon="back"></mat-icon>
          </strong>
        </span>
      </div>
      <div class="font-medium text-lg mx-2">
        User profile
      </div>
    </div>

    <div class="">
      <mat-tab-group mat-stretch-tabs>

        <div *ngIf="profile">
        <mat-tab label="User Profile">
          <div class="flex justify-center items-center mt-4">
            <div>
              <div class="h-40 w-40 rounded-2xl static border shadow-md"
                   [ngClass]="{'cursor-pointer': !isReadOnlyForProf}"
                   (click)="profilePicture.click()">
                <input type="file" [hidden]="true" #profilePicture accept="image/*"
                       (change)="selectedImageForPro($event.target.files[0])"/>
                <div class="absolute flex justify-center items-center">
                  <div class="flex justify-center w-40 h-40 items-center"
                       *ngIf="profile.profilePhoto != '' && !changedImage">
<!--                    {{fileServer + profile.profilePhoto}}-->
                    <img [src]="fileServer + profile.profilePhoto"
                         *ngIf="!changedImage"/>
                  </div>
                  <div class="flex justify-center w-40 h-40 items-center"
                       *ngIf="changedImage">
                    <img [src]="imageFromFile"
                         *ngIf="changedImage"/>
                  </div>

                  <div class="h-40 w-40 rounded-2xl bg-primary-500"
                  *ngIf="!changedImage && profile.profilePhoto === ''">
                    <mat-icon class="profile-picture" svgIcon="person2"></mat-icon>
                  </div>
                </div>
                <div
                  *ngIf="!isReadOnlyForProf"
                  class="absolute w-40 rounded-t-2xl p-2 font-medium text-white text-center"
                  style="background: rgba(9,61,114,0.6)">
                  Change Profile
                </div>
              </div>
            </div>
          </div>
          <form class="m-4" [formGroup]="userProfileForm" autocomplete="off" (ngSubmit)="submitForUserProfile(userProfileForm.value)">
            <div class="flex justify-between items-center mt-4">
              <div class="row">
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Title" formControlName="profileTitle" matInput
                           [readonly]="isReadOnlyForProf"/>
                    <mat-icon matPrefix svgIcon="badge" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userProfileForm.get('profileTitle').valid && userProfileForm.get('profileTitle').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="First Name" formControlName="userFirstName" matInput
                           [readonly]="isReadOnlyForDes"/>
                    <mat-icon matPrefix svgIcon="user" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userProfileForm.get('userFirstName').valid && userProfileForm.get('userFirstName').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Last Name" formControlName="userLastName" matInput
                           [readonly]="isReadOnlyForDes"/>
                    <mat-icon matPrefix svgIcon="user" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userProfileForm.get('userLastName').valid && userProfileForm.get('userLastName').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Email" formControlName="userEmail" matInput
                           [readonly]="isReadOnlyForDes"/>
                    <mat-icon matPrefix svgIcon="email" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userProfileForm.get('userEmail').valid && userProfileForm.get('userEmail').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Phone Number" formControlName="profilePhone" matInput
                           [readonly]="isReadOnlyForProf"/>
                    <mat-icon matPrefix svgIcon="phone" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userProfileForm.get('profilePhone').valid && userProfileForm.get('profilePhone').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Designation Name" formControlName="designationName" matInput
                           [readonly]="isReadOnlyForDes"/>
                    <mat-icon matPrefix svgIcon="badge" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userProfileForm.get('designationName').valid && userProfileForm.get('designationName').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Designation Short-form" formControlName="designationShortForm" matInput
                           [readonly]="isReadOnlyForDes" />
                    <mat-icon matPrefix svgIcon="user" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userProfileForm.get('designationShortForm').valid && userProfileForm.get('designationShortForm').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="flex justify-end mt-2">
              <button *ngIf="isReadOnlyForProf; else submitUpdatesForProf" mat-button class="bg-gradient2" type="button"
                      (click)="isReadOnlyForProf = false">Edit Profile
              </button>
              <ng-template #submitUpdatesForProf>
                <button mat-button class="danger-btn mx-3" type="button"
                        (click)="isReadOnlyForProf = true">Cancle
                </button>
                <button mat-button class="bg-gradient2" type="submit">Save
                </button>
              </ng-template>
            </div>
          </form>
        </mat-tab>
        </div>


       <div *ngIf="institution">
        <mat-tab label="Institution Profile">

          <div class="flex justify-center items-center mt-4">
            <div>
              <div class="h-40 w-40 rounded-2xl static border shadow-md"
                   [ngClass]="{'cursor-pointer': !isReadOnlyForInst}"
                   (click)="profilePicture.click()">
                <input type="file" [hidden]="true" #profilePicture accept="image/*"
                       (change)="selectedImageForInstu($event.target.files[0])"/>
                <div class="absolute flex justify-center items-center">
                  <div class="flex justify-center w-40 h-40 items-center"
                       *ngIf="institution?.institutionLogo != '' && !changedImageForInstu">
                    <img [src]="fileServer + institution?.institutionLogo"
                         *ngIf="!changedImageForInstu"/>
                  </div>
                  <div class="flex justify-center w-40 h-40 items-center"
                       *ngIf="changedImageForInstu">
                    <img [src]="imageFromFileForInstu"
                         *ngIf="changedImageForInstu"/>
                  </div>

                  <div class="h-40 w-40 rounded-2xl bg-primary-500"
                  *ngIf="!changedImageForInstu && institution?.institutionLogo === ''">
                    <mat-icon class="profile-picture" svgIcon="person2"></mat-icon>
                  </div>
                </div>
                <div
                  *ngIf="!isReadOnlyForInst"
                  class="absolute w-40 rounded-t-2xl p-2 font-medium text-white text-center"
                  style="background: rgba(9,61,114,0.6)">
                  Change Profile
                </div>
              </div>
            </div>
          </div>
          <form class="m-4" [formGroup]="userInstutionForm" autocomplete="off" (ngSubmit)="submitForInstution(userInstutionForm.value)">
            <div class="flex justify-between items-center mt-4">

              <div class="row">
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Institution Name" formControlName="institutionName" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="institution" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('institutionName').valid && userInstutionForm.get('institutionName').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
               <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Institution Short-form" formControlName="institutionShortform" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="user" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('institutionShortform').valid && userInstutionForm.get('institutionShortform').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Physical Address" formControlName="institutionPhysicalAddress" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="location" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('institutionPhysicalAddress').valid && userInstutionForm.get('institutionPhysicalAddress').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Email" formControlName="institutionEmail" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="email" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('institutionEmail').valid && userInstutionForm.get('institutionEmail').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Post Code" formControlName="institutionPostcode" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="post_code" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('institutionPostcode').valid && userInstutionForm.get('institutionPostcode').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Website" formControlName="institutionWebsite" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="api" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('institutionWebsite').valid && userInstutionForm.get('institutionWebsite').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Phone Number" formControlName="institutionPhones" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="phone" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('institutionPhones').valid && userInstutionForm.get('institutionPhones').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Map URL" formControlName="institutionMapUrl" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="api" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('institutionMapUrl').valid && userInstutionForm.get('institutionMapUrl').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Ministry" formControlName="ministryName" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="info" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('ministryName').valid && userInstutionForm.get('ministryName').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-md-4">
                  <mat-form-field appearance="outline" class="material-form w-full">
                    <input placeholder="Sector" formControlName="sectorName" matInput
                           [readonly]="isReadOnlyForInst"/>
                    <mat-icon matPrefix svgIcon="info" class="mx-2"></mat-icon>
                    <mat-error>
                    <span
                      *ngIf="!userInstutionForm.get('sectorName').valid && userInstutionForm.get('sectorName').touched">
                        Field is required
                    </span>
                    </mat-error>
                  </mat-form-field>
                </div>

              </div>
            </div>
            <div class="flex justify-end mt-2">
              <button *ngIf="isReadOnlyForInst; else submitUpdatesForInst" mat-button class="bg-gradient2" type="button"
                      (click)="isReadOnlyForInst = false">Edit Institution
              </button>
              <ng-template #submitUpdatesForInst>
                <button mat-button class="danger-btn mx-3" type="button"
                        (click)="isReadOnlyForInst = true">Cancel
                </button>
                <button mat-button class="bg-gradient2" type="submit">Save
                </button>
              </ng-template>
            </div>
          </form>
        </mat-tab>
       </div>

      </mat-tab-group>
    </div>
  </div>
</div>
